<div class="p-datatable-wrapper overflow-scroll p-2">
    <div class="flex flex-row gap-2">
        <table class="w-full border-collapse">
            <tbody>
                @for (row of cells; let rowIndex = $index; track $index) {
                <tr>
                    @for (cell of row; let colIndex = $index; track $index) {
                    <td class="table-cell border border-gray-100 p-1 relative min-w-[8rem] max-h-[10rem] overflow-visible"
                        (mouseenter)="onCellHover(rowIndex, colIndex)" (mouseleave)="onCellLeave()">
                        <textarea pInputTextarea #textarea
                            class="w-full h-full max-h-[10rem] !border-none resize overflow-y-auto !outline-none !shadow-none bg-transparent"
                            [disabled]="disabled" [(ngModel)]="cells[rowIndex][colIndex]"
                            (input)="onCellUpdate($event, rowIndex, colIndex)" (blur)="onBlur.emit({ cells })"
                            rows="1"></textarea>

                        @if (rowIndex === 0 && !disabled) {
                        <div class="absolute top-[-0.5rem] left-1/2 -translate-x-1/2 flex itesm-center gap-1 z-10
                                    transition-opacity duration-300 ease-in-out
                                    " [class.opacity-100]="hoveredColumnIndex === colIndex"
                            [class.opacity-0]="hoveredColumnIndex !== colIndex"
                            [class.pointer-events-auto]="hoveredColumnIndex === colIndex"
                            [class.pointer-events-none]="hoveredColumnIndex !== colIndex">
                            <i class="pi pi-plus icon-sm" (click)="addColumn(colIndex)"></i>
                            <i class="pi pi-minus icon-sm" (click)="removeColumn(colIndex)"></i>
                        </div>
                        }

                        @if (colIndex === 0 && !disabled) {
                        <div class="absolute left-[-0.5rem] top-1/2 -translate-y-1/2 flex flex-col gap-1 z-10
                                    transition-opacity duration-300 ease-in-out
                                    " [class.opacity-100]="hoveredRowIndex === rowIndex"
                            [class.opacity-0]="hoveredRowIndex !== rowIndex"
                            [class.pointer-events-auto]="hoveredRowIndex === rowIndex"
                            [class.pointer-events-none]="hoveredRowIndex !== rowIndex">
                            <i class="pi pi-plus icon-sm" (click)="addRow(rowIndex)"></i>
                            <i class="pi pi-minus icon-sm" (click)="removeRow(rowIndex)"></i>
                        </div>
                        }
                    </td>
                    }
                </tr>
                }
            </tbody>
        </table>
    </div>
</div>
